"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEmailService = void 0;
var _httpClientFactory = require("../api/httpClientFactory");
/**
 * @typedef {import('axios').Axios} AxiosInstance
 * @typedef {import('axios').CancelToken}
 */
/**
 * @typedef {Object} Self
 * @property {() => AxiosInstance} getHttpClient 
 */
var MIDDLEWARE_URL = process.env.MIDDLEWARE_BASE_URL;
var BASE_PATH = '/GlmEmail';

/**
 * @param {path} string
 */
var buildUrl = function buildUrl(path) {
  var slashEnsured = path.startsWith('/') ? path : "/".concat(path);
  return "".concat(MIDDLEWARE_URL).concat(BASE_PATH).concat(slashEnsured);
};
var _sendQuoteSummaryEmail = function sendQuoteSummaryEmail(self, quote) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    usePartnerEmail: false
  };
  var url = buildUrl("/Message/Send/QuoteSummary/".concat(config.usePartnerEmail));
  return self.getHttpClient().post(url, quote);
};

/**
 * 
 * @param { Self } self 
 * @param { Object } quote 
 * @param { Object } config 
 * @returns 
 */
var _sendReferToUnderwriterEmail = function sendReferToUnderwriterEmail(self, quote) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    usePartnerEmail: false
  };
  var url = buildUrl("/Message/Send/ReferUw/".concat(config.usePartnerEmail));
  return self.getHttpClient().post(url, quote);
};

/**
 * @param { Self } self 
 * @param { Object } quote
 * @param { Object } config
 * @returns 
 */
var _sendConfirmationEmail = function sendConfirmationEmail(self, quote, config) {
  var url = buildUrl("/Message/Send/Confirmation/".concat(config.usePartnerEmail));
  return self.getHttpClient().post(url, quote);
};

/**
 * 
 * @param {} aHttpClient 
 * @returns 
 */
var getEmailService = exports.getEmailService = function getEmailService(apiKey, clientId) {
  return function (aHttpClient) {
    var httpClient = aHttpClient !== null && aHttpClient !== void 0 ? aHttpClient : _httpClientFactory.httpClientFactory.create({
      apiKey: apiKey,
      clientId: clientId,
      hasApiKey: true
    });

    /** @type {Self} */
    var self = {
      getHttpClient: function getHttpClient() {
        return httpClient;
      }
    };
    return {
      /**
       * 
       * @param { Object } quote 
       * @param { Object } config 
       */
      sendQuoteSummaryEmail: function sendQuoteSummaryEmail(quote) {
        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          usePartnerEmail: false
        };
        return _sendQuoteSummaryEmail(self, quote, config);
      },
      /**
       * 
       * @param { Object } quote 
       * @param { Object } config 
       */
      sendReferToUnderwriterEmail: function sendReferToUnderwriterEmail(quote) {
        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          usePartnerEmail: false
        };
        return _sendReferToUnderwriterEmail(self, quote, config);
      },
      /**
       * 
       * @param { Object } quote 
       * @param { Object } config 
       */
      sendConfirmationEmail: function sendConfirmationEmail(quote) {
        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          usePartnerEmail: false
        };
        return _sendConfirmationEmail(self, quote, config);
      }
    };
  };
};